import { ArrowRight, Phone } from "lucide-react";

const HERO_BG =
  "https://images.unsplash.com/photo-1647427060118-4911c9821b82?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBtYW51ZmFjdHVyaW5nJTIwZmFjaWxpdHl8ZW58MHx8fHwxNzc5NDAyMDM4fDA&ixlib=rb-4.1.0&q=85";

export default function Hero() {
  const goTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      id="inicio"
      data-testid="hero-section"
      className="relative min-h-[100vh] flex items-center overflow-hidden"
    >
      {/* Background */}
      <div className="absolute inset-0 z-0">
        <img
          src={HERO_BG}
          alt="Taller industrial Guarda Flex"
          className="w-full h-full object-cover gf-hero-bg"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-[#0A1B35]/90 via-[#0A1B35]/70 to-[#061226]/85" />
        <div className="absolute inset-0 gf-grid-bg opacity-30" />
      </div>

      {/* Side rail */}
      <div className="hidden lg:flex absolute left-10 top-1/2 -translate-y-1/2 flex-col gap-6 z-10">
        <div className="w-px h-24 bg-gradient-to-b from-transparent via-[#00B4D8] to-transparent" />
        <span className="font-mono-accent text-[10px] uppercase tracking-[0.3em] text-white/70 -rotate-90 origin-center whitespace-nowrap">
          SCROLL · 01 / 06
        </span>
        <div className="w-px h-24 bg-gradient-to-b from-[#00B4D8] via-transparent to-transparent" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-10 py-32 w-full">
        <div className="max-w-4xl">
          <h1
            data-testid="hero-title"
            className="font-display font-black text-white text-4xl sm:text-5xl lg:text-6xl xl:text-7xl tracking-tighter leading-[1] mb-8 mt-8 gf-fade-up"
            style={{ animationDelay: "0.1s" }}
          >
            Fabricación, Reparación
            <br />
            y Mantenimiento de
            <br />
            <span className="text-[#00B4D8]">Guardas Telescópicas y Fuelles CNC en Querétaro.</span>
          </h1>

          <p
            data-testid="hero-slogan"
            className="text-white/85 text-lg sm:text-xl lg:text-2xl max-w-2xl leading-relaxed mb-12 gf-fade-up font-light"
            style={{ animationDelay: "0.2s" }}
          >
            Soluciones industriales integrales en Querétaro:
            fabricación a medida bajo plano o muestra, reparación urgente por
            impacto o colisión y mantenimiento preventivo con reemplazo de
            wipers y guías.
          </p>

          <div
            className="flex flex-col sm:flex-row gap-4 gf-fade-up"
            style={{ animationDelay: "0.3s" }}
          >
            <button
              onClick={() => goTo("contacto")}
              data-testid="cta-cotizar-ahora"
              className="gf-btn-primary"
            >
              Cotizar Ahora
              <ArrowRight size={18} />
            </button>
            <button
              onClick={() => goTo("contacto")}
              data-testid="cta-contactar-asesor"
              className="gf-btn-ghost-inverse"
            >
              <Phone size={16} />
              Contactar a un Asesor
            </button>
          </div>

          {/* Value strip */}
          <div
            className="mt-20 grid grid-cols-2 gap-px bg-white/15 max-w-2xl gf-fade-up"
            style={{ animationDelay: "0.4s" }}
          >
            {[
              { v: "24/7", l: "Respuesta a urgencias" },
              { v: "100%", l: "Fabricación a medida" },
            ].map((s) => (
              <div key={s.l} className="bg-[#0A1B35]/80 backdrop-blur-sm p-5">
                <div className="font-display font-black text-2xl text-[#00B4D8]">
                  {s.v}
                </div>
                <div className="text-white/70 text-xs uppercase tracking-wider mt-1">
                  {s.l}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Bottom border accent */}
      <div className="absolute bottom-0 inset-x-0 h-px bg-gradient-to-r from-transparent via-[#00B4D8]/60 to-transparent z-10" />
    </section>
  );
}
